<template>
  <el-dialog
    top="80px"
    width="600px"
    class="create-user-popup"
    :title="position ? 'Thay đổi thông tin' : 'Thêm vị trí Banner'"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-position="top">
      <el-form-item label="Tên vị trí" prop="summary">
        <el-input :value="`Banner ${positions.length + 1}`" readonly></el-input>
      </el-form-item>
      <el-form-item label="Đối tượng hiển thị" prop="options">
        <el-select
          v-model="form.options"
          filterable
          :disabled="callingAPI"
          placeholder="Chọn đối tượng hiển thị"
          class="w-100"
        >
          <el-option
            v-for="(place, index) in places"
            :key="index"
            :label="place.name"
            :value="place.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="callingAPI" @click="handleClose">Hủy</el-button>
      <el-button type="primary" :loading="callingAPI" @click="handleUpdatePosition()">Lưu</el-button>
    </span>
  </el-dialog>
</template>

<script>
import TYPE from '@/data/type'

export default {
  name: 'PositionFormPopup',
  props: {
    visible: Boolean,
    positions: Array,
    position: Object
  },
  data() {
    return {
      callingAPI: false,
      places: TYPE.PLACES,
      form: {
        options: this.position ? this.position.options : []
      }
    }
  },
  computed: {
  },
  methods: {
    handleUpdatePosition() {
    },

    handleClose() {
      this.$refs.form.resetFields()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>
<style lang="scss">
</style>
